class PluginAccountService {
    constructor (configUrl, httpClient) {
        this.httpClient = httpClient;
        this.consumerKeysUrl = `${configUrl}/consumer-keys`;
    }

    async getCustomerKeys () {
        const response = await this.httpClient.get(this.consumerKeysUrl, undefined, {
            ...this.httpClient.getWordpressRequestConfig(),
        });
        if (!response) {
            return null;
        }
        const { data } = response;
        const { consumer_secret: consumerSecret, consumer_key: consumerKey } = data;
        return {
            consumerSecret,
            consumerKey,
        };
    }

    async setCustomerKeys (consumerKey, consumerSecret) {
        const response = await this.httpClient.put(this.consumerKeysUrl, {
            consumer_key: consumerKey,
            consumer_secret: consumerSecret,
        }, undefined, {
            ...this.httpClient.getWordpressRequestConfig(),
        });
        if (!response) {
            return null;
        }
        return true;
    }
}

export default PluginAccountService;
